import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpService } from '@/app/services/http/http.service';
import { ReportScheduleDto, ReportScheduleInput } from './report-schedule.types';

@Injectable({ providedIn: 'root' })
export class ReportScheduleService {
  private readonly http = inject(HttpService);

  get(briefId: string): Observable<ReportScheduleDto | null> {
    return this.http
      .runHttpCall('GET', `/briefs/${briefId}/report-schedule`, 'application/json', undefined, true, { silentStatuses: [404] })
      .pipe(
        catchError((error: unknown) => {
          if (error instanceof HttpErrorResponse && error.status === 404) {
            return of(null);
          }
          return throwError(() => error);
        }),
      );
  }

  save(briefId: string, body: ReportScheduleInput): Observable<ReportScheduleDto> {
    return this.http.runHttpCall('PUT', `/briefs/${briefId}/report-schedule`, 'application/json', body);
  }

  stop(briefId: string): Observable<{ stopped: boolean }> {
    return this.http.runHttpCall('DELETE', `/briefs/${briefId}/report-schedule`, 'application/json');
  }

  nextRun(briefId: string, body: Pick<ReportScheduleInput, 'dayOfWeek' | 'timeOfDay' | 'timezone'>): Observable<{ nextRunAt: string; nextRunLocal: string }> {
    return this.http.runHttpCall('POST', `/briefs/${briefId}/report-schedule/next-run`, 'application/json', body);
  }

  preview(briefId: string, timezone: string): Observable<{ url: string }> {
    return this.http.runHttpCall('POST', `/briefs/${briefId}/report-preview`, 'application/json', { timezone });
  }
}
